var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenAiLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.929 19.6954C39.895 15.365 36.4117 11.8816 32.0813 9.84768C36.4117 7.81372 39.895 4.33035 41.929 0C43.9629 4.33035 47.4463 7.81372 51.7767 9.84768C47.4463 11.8816 43.9629 15.365 41.929 19.6954Z",
    fill: "#5AAD46",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7853 36.1575L52.8934 27.4111L57.0016 36.1575C59.7775 42.0674 64.5315 46.8214 70.4414 49.5973L79.1878 53.7055L70.4414 57.8136C64.5315 60.5895 59.7775 65.3435 57.0016 71.2534L52.8934 79.9998L48.7853 71.2534C46.0094 65.3435 41.2554 60.5895 35.3455 57.8136L26.5991 53.7055L35.3455 49.5973C41.2554 46.8214 46.0094 42.0674 48.7853 36.1575Z",
    fill: "#5CAB33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5637 45.4819C14.1039 38.1158 8.17856 32.1905 0.8125 28.7307C8.17856 25.2709 14.1039 19.3456 17.5637 11.9795C21.0235 19.3456 26.9488 25.2709 34.3149 28.7307C26.9488 32.1905 21.0235 38.1158 17.5637 45.4819Z",
    fill: "#5AAD46",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenAiLoader);
export default __webpack_public_path__ + "static/media/gen-ai-loader.4876e7b4326c6bdb22422304aa8a20c3.svg";
export { ForwardRef as ReactComponent };